// extracted by mini-css-extract-plugin
module.exports = {"menu":"PopupMenu_menu__18fIX","popup-menu-enter":"PopupMenu_popup-menu-enter__1PW6Y","scrim":"PopupMenu_scrim__1CMMO","item":"PopupMenu_item__3tWGv"};